import React from 'react';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { caseTypeOrganizationUnitDefaultScheme } from './Default/CaseTypeOrganizationUnitDefault';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

export interface CaseTypeOrganizationUnitFormValues {
	label: string;
	parentCaseTypeId?: SelectValue;
}

export interface CaseTypeOrganizationUnitFormDefaultValues {
	parentCaseTypeId?: string;
	label: string;
}

interface Props {
	onSuccess: (values: CaseTypeOrganizationUnitFormValues) => void;
	onRemove: () => void;
	workplaceId: string;
	defaultValues?: CaseTypeOrganizationUnitFormDefaultValues;
	isOnlyOneRoot: boolean;
	organizationUnitId?: string;
}

const CaseTypeOrganizationUnitForm: React.FC<Props> = ({
	onSuccess,
	onRemove,
	defaultValues,
	isOnlyOneRoot,
	organizationUnitId,
}) => {
	return (
		<MagicForm
			formScheme={caseTypeOrganizationUnitDefaultScheme(
				isOnlyOneRoot,
				organizationUnitId,
			)}
			onSubmit={onSuccess}
			removeButton={{
				onRemove,
			}}
			defaultValues={defaultValues}
		/>
	);
};

export default CaseTypeOrganizationUnitForm;
